import React from "react";
import PropTypes from "prop-types";

import Tooltip from "@mui/material/Tooltip";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ExampleCard({ image, name, count, pro, video }) {
  const mediaTemplate = video ? (
    <iframe
      title={name}
      src={video}
      width="100%"
      height="100%"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  ) : (
    <MKBox component="img" src={image} alt={name} width="100%" my="auto" opacity={pro ? 0.6 : 1} />
  );

  return (
    <MKBox position="relative">
      {pro ? (
        <Tooltip title="Pro Element" placement="top">
          {mediaTemplate}
        </Tooltip>
      ) : (
        mediaTemplate
      )}
      {(name || count > 0) && (
        <MKBox mt={1} ml={1} lineHeight={1}>
          {name && (
            <MKTypography variant="h6" fontWeight="bold">
              {name}
            </MKTypography>
          )}
          {count > 0 && (
            <MKTypography variant="button" fontWeight="regular" color="secondary">
              {count} {count === 1 ? "Example" : "Examples"}
            </MKTypography>
          )}
        </MKBox>
      )}
    </MKBox>
  );
}

// Setting default props for the ExampleCard
ExampleCard.defaultProps = {
  name: "",
  count: 0,
  pro: false,
};

// Typechecking props for the ExampleCard
ExampleCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string,
  count: PropTypes.number,
  pro: PropTypes.bool,
  video: PropTypes.string, // New prop type for the video URL
};

export default ExampleCard;
